import { css } from 'styled-components';
import token from 'styled-token';
import { StyledAvatar } from '../../components/Avatar/Avatar.styles';
import { StyledButtonIcon } from '../../components/ButtonIcon/ButtonIcon.styles';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var elevationCSS = function elevationCSS(props) {
  var chipElevation = props.chipElevation;
  if (!chipElevation) {
    return '';
  }
  return token({
    boxShadow: 'Chip.boxShadow.default'
  }, function (_ref) {
    var boxShadow = _ref.boxShadow;
    return css(["&:not(:focus-visible){box-shadow:", ";}"], boxShadow);
  })(props);
};

/** @class ChipMixin */
/** @method */
export var ChipMixin = function ChipMixin(props) {
  return token({
    avatarSize: "Chip.avatarSize",
    borderRadius: "Chip.borderRadius",
    fontType: "Chip.fontType",
    horizontalSpacing: "Chip.horizontalSpacing",
    iconSize: "Chip.iconSize",
    targetSize: "Chip.targetSize"
  }, function (_ref2) {
    var avatarSize = _ref2.avatarSize,
      borderRadius = _ref2.borderRadius,
      fontType = _ref2.fontType,
      horizontalSpacing = _ref2.horizontalSpacing,
      iconSize = _ref2.iconSize,
      targetSize = _ref2.targetSize;
    return css(["border-radius:", ";padding-right:", "px;padding-left:", "px;min-width:0;&:after{height:", "px;margin-top:-", "px;}", "{flex:0 0 auto;width:", "px;margin-right:", ";}", ",& > ", "{margin-right:", ";width:", "px;}", " ", " ", ""], borderRadius, horizontalSpacing, horizontalSpacing, targetSize, targetSize / 2, StyledAvatar, avatarSize, spaceMixin('xs'), StyledButtonIcon, StyledIcon, spaceMixin('xs'), iconSize, spacingMixin(props), typographyMixin(Object.assign({
      fontType: fontType
    }, props)), elevationCSS(props));
  })(props);
};